/* GDB star rating - confere as notas com o Converts em lote (1 fetch por pagina).
 *
 * A nota ja vem desenhada do servidor (snippets/star-rating.liquid, metafields
 * reviews.*). Aqui so aplica a config do painel e corrige nota que mudou depois
 * do cache da pagina.
 *
 * Fonte: app Converts (av-converts), RPC get_ratings_publicos, que devolve
 *   { config: { mostrar_badge, badge_zero }, ratings: { "<id>": {media,total} } }
 * A config do PAINEL manda no produto sem avaliacao:
 *   'convite' | 'estrelas' -> estrelas apagadas      'espaco' -> invisivel, altura reservada
 *   'ocultar' -> nada, nem espaco                    null     -> legado (estrelas apagadas)
 * mostrar_badge === false esconde o selo mesmo com avaliacao.
 *
 * Antes este arquivo lia o Supabase do app ANTIGO de avaliacoes
 * (get_reviews_summary_batch), que nao recebe mais avaliacao nenhuma: o selo
 * do topo da PDP ficava com 5 estrelas vazias enquanto a secao de baixo,
 * essa sim no Converts, mostrava a media certa.
 */
(function () {
  if (window.__gdbStarRatingLoaded) return;
  window.__gdbStarRatingLoaded = true;

  var SUPA_URL = 'https://xnmjhcvrhndtciezsuty.supabase.co';
  var SUPA_KEY = 'sb_publishable_nHlFXSrAVk1HzAknMrGorg_s4wnzgB0';
  var LOJA_ID = '2e8cc024-8e95-4448-b6d2-0b1bb2f421b2';
  var CACHE_KEY = 'gdb_sr_v2';
  var CACHE_TTL = 5 * 60 * 1000;

  var cache = {};
  var painel = null;
  try {
    var raw = sessionStorage.getItem(CACHE_KEY);
    if (raw) {
      var parsed = JSON.parse(raw);
      if (parsed && Date.now() - parsed.t < CACHE_TTL) {
        cache = parsed.d || {};
        painel = parsed.config || null;
      }
    }
  } catch (e) {}

  function saveCache() {
    try {
      sessionStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ t: Date.now(), d: cache, config: painel })
      );
    } catch (e) {}
  }

  function modoZero() {
    if (painel && painel.badge_zero) return painel.badge_zero;
    return 'estrelas';
  }

  function renderEl(el, media, total) {
    el.setAttribute('data-loaded', '1');

    // Painel pode desligar o selo de vez.
    if (painel && painel.mostrar_badge === false) {
      el.style.display = 'none';
      return;
    }

    if (total === 0) {
      var modo = modoZero();
      if (modo === 'ocultar') {
        el.style.display = 'none';
        return;
      }
      if (modo === 'espaco') {
        el.style.visibility = 'hidden';
        el.style.pointerEvents = 'none';
        el.setAttribute('aria-hidden', 'true');
        return;
      }
      // 'convite' | 'estrelas' | legado: estrelas apagadas, sem label.
    }

    // Camada preta cortada na largura da nota (ver gdb-star-rating.css).
    var v = total > 0 ? Math.max(0, Math.min(5, media)) : 0;
    el.style.setProperty('--sr-v', v);
    el.style.setProperty('--sr-f', Math.floor(v));
    var label = el.querySelector('.gdb-sr-label');
    if (label && el.getAttribute('data-show-label') !== 'false' && total > 0) {
      label.textContent = (Math.round(media * 10) / 10).toFixed(1);
      label.style.display = 'inline-block';
    } else if (label) {
      label.textContent = '';
      label.style.display = '';
    }
    if (total > 0 && !el.__gdbClick) {
      el.__gdbClick = true;
      el.style.cursor = 'pointer';
      el.addEventListener(
        'click',
        function () {
          var sec =
            document.getElementById('galeria-reviews') ||
            document.querySelector('[id^="galeria-reviews-"]') ||
            document.querySelector('.gdb-reviews-container');
          if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
        },
        { once: true }
      );
    }
  }

  var inFlight = false;

  function run() {
    var els = [].slice.call(document.querySelectorAll('.gdb-sr[data-product-id]:not([data-loaded])'));
    if (!els.length) return;

    var missing = [];
    els.forEach(function (el) {
      var pid = el.getAttribute('data-product-id');
      if (cache[pid]) renderEl(el, cache[pid].media, cache[pid].total);
      else if (missing.indexOf(pid) < 0) missing.push(pid);
    });
    if (!missing.length || inFlight) return;

    inFlight = true;
    fetch(SUPA_URL + '/rest/v1/rpc/get_ratings_publicos', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: SUPA_KEY,
        Authorization: 'Bearer ' + SUPA_KEY
      },
      body: JSON.stringify({ p_loja_id: LOJA_ID, p_shopify_ids: missing })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var ratings = (data && data.ratings) || {};
        painel = (data && data.config) || null;
        Object.keys(ratings).forEach(function (pid) {
          cache[pid] = {
            media: Number(ratings[pid].media) || 0,
            total: Number(ratings[pid].total) || 0
          };
        });
        missing.forEach(function (pid) {
          if (!cache[pid]) cache[pid] = { media: 0, total: 0 };
        });
        saveCache();
      })
      .catch(function () {})
      .then(function () {
        inFlight = false;
        document.querySelectorAll('.gdb-sr[data-product-id]:not([data-loaded])').forEach(function (el) {
          var d = cache[el.getAttribute('data-product-id')] || { media: 0, total: 0 };
          renderEl(el, d.media, d.total);
        });
      });
  }

  function schedule() {
    if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 500 });
    else setTimeout(run, 0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();

  /* Paginacao/filtros que injetam novos cards */
  var mo = new MutationObserver(function () {
    if (document.querySelector('.gdb-sr[data-product-id]:not([data-loaded])')) schedule();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
